import React, { useContext, useState } from "react";
import { NavBar } from "./navigation/nav-bar";
import { PageFooter } from "./page-footer";
import SideMenu from "./side-menu";
import { ProfileContext } from "../contexts/ProfileContext";
import styled from "styled-components";
import Sidemenunew from "./Side-menu-new";

export const PageLayout = ({ children }) => {
  const { worker, organizationImage } = useContext(ProfileContext);
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <Layout>
      {/* <NavBar /> */}
      {worker && (
        // <SideMenu
        //   userRole={worker.role}
        //   userName={worker.fullName}
        //   userImage={organizationImage}
        //   onToggle={setIsExpanded}
        // />
        <Sidemenunew
          userRole={worker.role}
          userName={worker.fullName}
          userImage={organizationImage}
          onToggle={setIsExpanded}
        />
      )}
      <MainContent
        className={`main-content ${isExpanded ? "expanded" : ""}`}
        $hasWorker={!!worker}
      >
        <div className="page-layout__content p-4 sm:p-6 md:p-8 lg:p-12 m-4">
          {children}
        </div>

        <PageFooter isExpanded={isExpanded} hasWorker={!!worker} />
      </MainContent>
    </Layout>
  );
};

const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  position: relative;
  width: 100%;
`;

const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin-left: ${(props) => (props.$hasWorker ? "64px" : "0")};
  width: ${(props) => (props.$hasWorker ? "calc(100% - 64px)" : "100%")};
  transition: all 0.3s ease-in-out;

  &.expanded {
    margin-left: ${(props) => (props.$hasWorker ? "256px" : "0")};
    width: ${(props) => (props.$hasWorker ? "calc(100% - 256px)" : "100%")};
  }
`;
